var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},[React.createElement("rect",{"y":"2","width":"2","height":"32","transform":"rotate(-90 0 2)","fill":"white","className":"nostroke","key":0}),React.createElement("rect",{"y":"13","width":"2","height":"32","transform":"rotate(-90 0 13)","fill":"white","className":"nostroke","key":1}),React.createElement("rect",{"y":"24","width":"2","height":"32","transform":"rotate(-90 0 24)","fill":"white","className":"nostroke","key":2})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"32","height":"24","fill":"white"})))]);
}

Menu.defaultProps = {"width":"32","height":"20","viewBox":"0 0 32 24","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
